import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useOktaAuth } from "@okta/okta-react";
import { useState } from "react";
import axiosInstance from "../../api";

type TogglePayload = {
  isReleasePopupButtonEnabled: boolean;
};

export const useToggleReleasePopupMutation = () => {
  // const okta = useOktaAuth();
  // const authState = okta?.authState;
  const { authState } = useOktaAuth();
  const queryClient = useQueryClient();
  const [toggling, setToggling] = useState<boolean>(false);

  const toggleReleasePopup = async (payload: TogglePayload) => {
    const config = {
      headers: {
        Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
      },
    };

    const response = await axiosInstance.patch(
      "/v1/users/toggle-release-popup-button",
      payload,
      config
    );

    return response.data;
  };

  const mutation = useMutation({
    mutationFn: toggleReleasePopup,
    onMutate: async () => {
      setToggling(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["userSettings"] });
    //   toastMessages.success("Release popup button toggled.");
    },
    onError: (error) => {
    //   console.error("Toggle error:", error);
    //   toastMessages.error("Failed to toggle release popup button.");
    },
    onSettled: () => {
      setToggling(false);
    },
  });

  return { mutation, toggling };
};
